export enum PopupType {
    DELETE_FLEET = 'DELETE_FLEET',
    DELETE_USER = 'DELETE_USER',
    DELETE_POI = 'DELETE_POI',
    DELETE_AOI = 'DELETE_AOI',
    BLOCK_USER = 'BLOCK_USER',
    UNBLOCK_USER = 'UNBLOCK_USER',
    DELETE_FLEET_CAR = 'DELETE_FLEET_CAR',
    DELETE_ALERT = 'DELETE_ALERT',
    CONFIRM_ORDER = 'CONFIRM_ORDER',
    CANCEL_ORDER = 'CANCEL_ORDER',
    CANCEL_DATE = 'CANCEL_DATE',
    COLLISION_URL_EXTERNAL = 'COLLISION_URL_EXTERNAL',
    EMPTY = 'EMPTY',
    CAR_ROAD_URL_EXTERNAL = 'CAR_ROAD_URL_EXTERNAL',
    RESET_PASSWORD = 'RESET_PASSWORD',
    CONFIRM_TURN_ON = 'CONFIRM_TURN_ON',
    CONFIRM_TURN_OFF_SIM = 'CONFIRM_TURN_OFF_SIM'
}

export enum PopupTemplate {
    OK_TEMPLATE = 'OK_TEMPLATE',
    OK_CANCEL_TEMPLATE = 'OK_CANCEL_TEMPLATE'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/ViewManagementEnumTypes.ts